import { render, staticRenderFns } from "./HostApp.vue?vue&type=template&id=e5410116&"
import script from "./HostApp.vue?vue&type=script&lang=ts&"
export * from "./HostApp.vue?vue&type=script&lang=ts&"
import style0 from "./HostApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports